import { FC } from 'react'

const DhlIcon: FC = () => (
  <svg
    width="50"
    height="20"
    viewBox="0 0 50 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="50"
      height="20"
      rx="5"
      fill="#FFCC00"
    />
    <g clipPath="url(#clip0_42964_865283)">
      <path
        d="M52.985 3.32617V15.6828H-3.00781V3.32617H52.985Z"
        fill="#FFCC00"
      />
      <path
        d="M6.83972 5.54492L5.05078 7.97534C5.05078 7.97534 14.3249 7.97534 14.8006 7.97534C15.2934 7.97534 15.2869 8.1626 15.046 8.48892C14.8014 8.82018 14.392 9.39628 14.1428 9.73277C14.0164 9.90354 13.7878 10.2147 14.5454 10.2147C15.3464 10.2147 18.5325 10.2147 18.5325 10.2147C18.5325 10.2147 19.1751 9.34008 19.7137 8.60902C20.4466 7.61455 19.7773 5.54502 17.1574 5.54502C14.8124 5.54492 6.83972 5.54492 6.83972 5.54492Z"
        fill="#D2002E"
      />
      <path
        d="M4.32422 13.4632L7.9174 8.58105C7.9174 8.58105 11.9007 8.58105 12.3763 8.58105C12.8691 8.58105 12.8627 8.76831 12.6218 9.09463C12.3772 9.42589 11.9611 9.99587 11.7119 10.3324C11.5854 10.5031 11.3568 10.8147 12.1143 10.8147C12.9154 10.8147 18.0879 10.8147 18.0879 10.8147C17.5911 11.4953 15.9796 13.4632 13.0861 13.4632C10.7411 13.4632 4.32422 13.4632 4.32422 13.4632Z"
        fill="#D2002E"
      />
      <path
        d="M24.9049 10.8135L22.9564 13.4626H17.8164C17.8164 13.4626 19.7639 10.8141 19.7655 10.8141L24.9049 10.8135Z"
        fill="#D2002E"
      />
      <path
        d="M32.779 10.2147H20.207L23.645 5.54492H28.7834L26.8129 8.22255H29.1065L31.0778 5.54492H36.2157L32.779 10.2147Z"
        fill="#D2002E"
      />
      <path
        d="M32.3375 10.8145L30.3881 13.4629H25.25C25.25 13.4629 27.1975 10.8145 27.1991 10.8145H32.3375Z"
        fill="#D2002E"
      />
      <path
        d="M43.3314 5.54492L39.894 10.2146H34.4492C34.4492 10.2146 37.8874 5.54492 37.8891 5.54492H43.3314Z"
        fill="#D2002E"
      />
      <path
        d="M34.0085 10.8145C34.0085 10.8145 33.6329 11.3277 33.4505 11.5745C32.805 12.4467 33.3756 13.4629 35.4819 13.4629C37.9143 13.4629 43.7339 13.4629 43.7339 13.4629L45.6832 10.8145H34.0085Z"
        fill="#D2002E"
      />
    </g>
    <defs>
      <clipPath id="clip0_42964_865283">
        <rect
          width="42"
          height="8"
          fill="white"
          transform="translate(4 6)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default DhlIcon
